import Cookies from 'js-cookie';

export const Experiments = {
  dedupe(string) {
    const values = string.split('&');
    const uniqueMap = new Map();
    for (const value of values) {
      splitValue = value.split(':');
      if (splitValue.length == 2) {
        uniqueMap.set(splitValue[0], splitValue[1]);
      }
    }
    let uniqueValueString = '';
    for (const pair of uniqueMap.entries()) {
      uniqueValueString = uniqueValueString + pair[0] + ':' + pair[1] + '&';
    }
    return uniqueValueString.substring(0, uniqueValueString.length - 1);
  },
  mounted() {
    const existing = Cookies.get('optimizelyexperiencekeys');
    if (existing) {
      Cookies.set(
        'optimizelyexperiencekeys',
        this.dedupe(existing + '&' + this.el.dataset.cookies)
      );
    } else {
      Cookies.set('optimizelyexperiencekeys', this.el.dataset.cookies);
    }
  }
};
